import type { FunctionComponent } from 'react';

import {
  FinanceStatusTag,
  SkeletonLoader,
  StatusTagStatus,
} from '@kanda-libs/ks-design-library';

import {
  CLASS_NAMES,
  SKELETON_PROPS,
} from 'components/job/JobLayout/JobFinanceStatus/constants';
import useJobFinanceStatusProps from 'components/job/JobLayout/JobFinanceStatus/useJobFinanceStatusProps';
import PriceStatus from 'components/job/JobTable/PriceStatus';

const JobFinanceStatus: FunctionComponent = function () {
  const {
    financeStatus,
    timestamp,
    status,
    price,
    isLoading = false,
  } = useJobFinanceStatusProps();

  return (
    <>
      <SkeletonLoader
        {...SKELETON_PROPS}
        isLoading={isLoading}
        afterLoading={
          <FinanceStatusTag
            status={financeStatus as StatusTagStatus}
            timestamp={timestamp as unknown as number}
            size={28}
            variant="solid"
            className={CLASS_NAMES.statusTag}
          />
        }
      />
      <SkeletonLoader
        {...SKELETON_PROPS}
        isLoading={isLoading}
        afterLoading={
          <PriceStatus
            status={status}
            total={price as number}
            financeStatus={financeStatus}
            inline={false}
          />
        }
      />
    </>
  );
};

export default JobFinanceStatus;
